import type { Track, TrackGroups, Tracks } from "../../types.ts";
import { getTrackOffsetY } from "./track-offset.ts";

export function getHoveredTrack(trackGroups: TrackGroups, tracks: Tracks, yPos: number) {
  const trackIdsOfVisibleGroups = [...trackGroups.values()]
    .filter((group) => group.graphics.isVisible)
    .flatMap((group) => group.trackIds);

  const visibleTracks = trackIdsOfVisibleGroups
    .map((id) => tracks.get(id))
    .filter((track): track is Track => !!track && track.isVisible);

  for (const track of visibleTracks) {
    const offsetY = getTrackOffsetY(trackGroups, tracks, track.trackId);

    if (yPos >= 0 && yPos < offsetY + track.height) {
      return track;
    }
  }
  return;
}
